import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import { Tabs, Form, Input, message } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import Cookies from 'js-cookie'
import * as API from '../../../../api'
import * as LOGIN_API from '../../../../api/loginNew'
import * as UTILS from '../../../../utils'
import { addUserInfo, setCurrentLogin } from '../../../../redux/reducers/baseInfo'
import './index.less'

declare const window: Window & { onSuccess: any }

export interface LoginFormProps {
	goRegister?: () => void
	goStaffLogin?: () => void
	goResetPassword?: () => void
}

const { TabPane } = Tabs

const LoginForm: React.FC<LoginFormProps> = ({ goRegister, goStaffLogin, goResetPassword }) => {
	const history = useHistory()
	const dispatch = useDispatch()

	const [activeTab, setActiveTab] = useState<string>('pwd')
	const [submitEnabled, setSubmitEnabled] = useState<boolean>(false)

	const [getVercodeEnabled, setGetVerCodeEnabled] = useState<boolean>(false)
	const [count, setCount] = useState<number>(60)
	const [isSend, setIsSend] = useState<boolean>(false) // 是否已经发送验证码

	const [errorTips, setErrorTips] = useState<string>('') // 错误提示
	const [loading, setLoading] = useState<boolean>(false)

	const [pwdForm] = Form.useForm()
	const [codeForm] = Form.useForm()

	useEffect(() => {
		// 人机验证成功回调
		window.onSuccess = async (response, type) => {
			const vparams = {
				jy_project_id: 'uk7bj.java.nmapi',
				jy_type: type,
				jy_response: response,
			}
			const formMap = {
				pwd: {
					form: pwdForm,
					submit: API.Login.signIn,
					errorTips: '请输入正确的账号和密码',
				},
				code: {
					form: codeForm,
					submit: API.Login.signInByCode,
					errorTips: '账号或验证码输入错误',
				},
			}

			if (!formMap[activeTab]) return
			const params = { ...formMap[activeTab].form.getFieldsValue(), ...vparams }
			try {
				setLoading(true)
				setErrorTips('')
				const { code, data, msg } = await formMap[activeTab].submit(params)
				if (code !== 0) {
					setErrorTips(msg)
					setLoading(false)
					return
				}
				const { token, account } = data
				const { userid, username, workid } = account
				Cookies.set("access_token", token)
				/// 新权限
				const {
					code: RoleInfoCode,
					msg: RoleInforMsg,
					result: RoleInfoResult,
				} = await LOGIN_API.getRoleInfoNew({
					accessToken: token,
					userId: userid,
				})
				if (RoleInfoCode !== '0000') {
					setErrorTips(RoleInforMsg)
					message.error('权限获取失败')
					return
				}
				const permission = RoleInfoResult.menuEntityList
					? RoleInfoResult.menuEntityList.map(({ menuValue, menuName, ...rest }) => ({
							resourceVal: menuValue,
							nameCn: menuName,
							...rest,
					  }))
					: []
				const accountInfo = {
					ispublicnetwork: 1,
					userType: 'IOCenter',
					userid,
					username,
					workid: workid,
					workId: workid,
				}
				dispatch(
					addUserInfo({
						...accountInfo,
						permission,
					})
				)
				dispatch(setCurrentLogin(''))
				history.replace(`/`)
				setLoading(false)
			} catch (error) {
				message.error('登录失败')
				setLoading(false)
			}
		}
	}, [pwdForm, codeForm, activeTab])

	const goToRegister = () => {
		goRegister && goRegister()
	}
	const goToStaffLogin = () => {
		dispatch(setCurrentLogin(''))
		goStaffLogin && goStaffLogin()
	}
	const goToResetPassword = () => {
		goResetPassword && goResetPassword()
	}

	const formValidate = form => {
		if (!form.isFieldsTouched()) return
		setGetVerCodeEnabled(/^1[3-9]\d{9}$/.test(form.getFieldValue('userPhone')))
		setTimeout(() => {
			const objValidate = UTILS.objValidate(form.getFieldsValue())
			const errors = form.getFieldsError().filter(item => item.errors.length > 0)
			setSubmitEnabled(objValidate && errors.length === 0)
		}, 0)
	}

	const onTabsChange = val => {
		const tabFormMap = {
			pwd: pwdForm,
			code: codeForm,
		}
		setActiveTab(val)
		formValidate(tabFormMap[val])
	}

	/**
	 * 获取验证码
	 */
	const getVerCode = async () => {
		const userPhone = codeForm.getFieldValue('userPhone')
		try {
			setIsSend(true)
			const { code, msg } = await API.Login.sendCode({ userPhone })
			if (code === 0 || code === 10030) {
				message.info(msg || '验证码已发送')
			} else {
				message.error(msg)
				setIsSend(false)
			}
		} catch (error) {
			message.error('验证码发送失败')
			setIsSend(false)
		}
	}

	useEffect(() => {
		let timer
		if (isSend && count) {
			timer = setInterval(() => {
				setCount(n => {
					if (n === 0) {
						setIsSend(false)
						clearInterval(timer)
					}
					return n - 1
				})
			}, 1000)
		} else {
			setCount(60)
		}
		return () => clearInterval(timer)
	}, [isSend])

	/**
	 * 登录
	 */
	const onSubmit = () => {
		if (!submitEnabled) return
		// 触发人机验证，写在 /public/index.html 里
		const loginBtn = document.body.querySelector('#login') as HTMLElement
		loginBtn.click()
	}

	return (
		<div className="login-form">
			<div className="login-form-inner">
				<Tabs defaultActiveKey="pwd" size="small" onChange={onTabsChange}>
					<TabPane tab="外部账号登录" key="pwd">
						<Form form={pwdForm} onValuesChange={() => formValidate(pwdForm)}>
							<Form.Item name="userPhone">
								<Input placeholder="手机号" autoComplete="off" />
							</Form.Item>

							<Form.Item name="password">
								<Input type="password" placeholder="请输入密码" />
							</Form.Item>
						</Form>
					</TabPane>
					<TabPane tab="验证码登录" key="code">
						<Form form={codeForm} onValuesChange={() => formValidate(codeForm)}>
							<Form.Item
								name="userPhone"
								rules={[{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }]}
							>
								<Input placeholder="手机号" autoComplete="off" />
							</Form.Item>

							<Form.Item name="checkCode">
								<Input
									placeholder="请输入验证码"
									autoComplete="off"
									suffix={
										getVercodeEnabled ? (
											isSend ? (
												<div className="vercode-btn waiting">重新获取{count}s</div>
											) : (
												<div className="vercode-btn active" onClick={getVerCode}>
													获取验证码
												</div>
											)
										) : (
											<div className="vercode-btn">获取验证码</div>
										)
									}
								/>
							</Form.Item>
						</Form>
					</TabPane>
				</Tabs>

				<div style={{ textAlign: 'right', marginTop: '16px' }}>
					<span className="link" onClick={goToResetPassword}>
						忘记密码
					</span>
				</div>

				{loading ? (
					<div
						className="submit-button active"
						style={{ boxShadow: 'inset 0 0 1000px rgba(255, 255, 255, 0.3)' }}
					>
						<LoadingOutlined />
						登录
					</div>
				) : (
					<div
						className={submitEnabled ? 'submit-button active' : 'submit-button'}
						onClick={onSubmit}
					>
						登录
					</div>
				)}
				<div style={{ textAlign: 'center' }}>
					<span className="link" onClick={goToRegister}>
						账号注册
					</span>
				</div>
				<div className="extra">
					<span className="error-tips">{errorTips}</span>
				</div>
			</div>
			<div className="extent" onClick={goToStaffLogin}>
				<p>员工一键登录</p>
				<span>(需要连接同程内网)</span>
			</div>
		</div>
	)
}

export default connect()(LoginForm)
